export const legacyLoansDataGetters = {
  LEGACY_LOANS_DATA: 'LEGACY_LOANS_DATA'
}

export const UPDATE_LEGACY_LOANS_DATA = 'UPDATE_LEGACY_LOANS_DATA'
